const STORAGE_KEY =
  "yaman-mobile-meal-columns";


export const setMobileMealColumns =
  (columns) =>
  (dispatch) => {
    const safeColumns =
      columns === "one"
        ? "one"
        : "two";

    try {
      localStorage.setItem(
        STORAGE_KEY,
        safeColumns
      );
    } catch (error) {
      // Redux سيعمل حتى لو
      // localStorage غير متاح
    }

    dispatch({
      type:
        "set_mobile_meal_columns",

      payload:
        safeColumns,
    });
  };


export const toggleMobileMealColumns =
  () =>
  (
    dispatch,
    getState
  ) => {
    const current =
      getState()
        ?.Layout
        ?.mobileMealColumns ||
      "two";

    const next =
      current === "two"
        ? "one"
        : "two";

    dispatch(
      setMobileMealColumns(
        next
      )
    );
  };